import { TFunction } from 'i18next'
import { Attachment } from '@/modules/Upload/types'
import { ContractService } from '@/modules/Contract/types'

export type Subcontract = {
    contract_id: number
    employee_id: number | null
    contract_number_id: string | null
    customer_id: number | null
    customer_name: string | null
    company_name: string | null
    employee_name?: string | null
    service_id: number | null
    subcontract_code: string
    subcontract_effective_date?: string | null
    subcontract_expiry_date?: string | null
    subcontract_id: number
    subcontract_name: string | null
    subcontract_note: string | null
    subcontract_status: 'pending' | 'active' | 'completed'
    subcontract_register_date: string | null
    attachments: Attachment[]
    service_name?: string | null
    service_ids?: number[]
    services?: ContractService[]
}

export const subcontractStatus = (t: TFunction) => {
    return [
        { label: t('subcontract_status.pending'), value: 'pending' },
        { label: t('subcontract_status.active'), value: 'active' },
    ]
}
